import React from 'react';
import { default as bemCssModules } from 'bem-css-modules';
import { QuickBuy } from '../QuickBuy/QuickBuy';
import { useStore } from '../../store/AppStore';
import { default as ShadeStyles } from './Shade.module.css';
const style = bemCssModules(ShadeStyles);
const shadeColor = (colorHexCodes, colorImageUrl) => {
    if (colorHexCodes.length > 1) {
        return (React.createElement("span", { className: style('color'), style: {
                background: `linear-gradient(to right, ${colorHexCodes[0]}, ${colorHexCodes[0]} 50%, ${colorHexCodes[1]} 50%`
            } }));
    }
    if (colorHexCodes.length) {
        return (React.createElement("span", { className: style('color'), style: { backgroundColor: colorHexCodes[0] } }));
    }
    if (colorImageUrl) {
        return (React.createElement("img", { className: style('color'), src: colorImageUrl }));
    }
    return React.createElement("span", { className: style('shade') });
};
export const Shade = (props) => {
    const { setActiveShade, activeShade } = useStore();
    const onClick = () => {
        setActiveShade(props.code);
    };
    return (React.createElement("div", { className: style({ 'is-active': Boolean((activeShade === null || activeShade === void 0 ? void 0 : activeShade.code) === props.code) }), onClick: onClick },
        React.createElement("div", { className: style('icon') }, shadeColor(props.colorHexCodes, props.colorImageUrl)),
        React.createElement("div", { className: style('info') },
            React.createElement("div", { className: style('line') },
                React.createElement("span", { className: style('name') }, props.name),
                React.createElement("span", { className: style('price') }, props.price)),
            React.createElement("div", { className: style('line') },
                React.createElement("span", { className: style('code') }, props.code),
                React.createElement("span", { className: style('old-price') }, props === null || props === void 0 ? void 0 : props.oldPrice))),
        React.createElement("div", { className: style('quickbuy') },
            React.createElement(QuickBuy, { code: props.code }))));
};
